module.exports = __webpack_public_path__ + "static/media/ae-logo-color.4884428d.svg";